import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetExpenseClaimsQuery } from '../../../../src/app/Slices/SevenDayApiSlice';
import UserRole from '../../../shared/AuthRoles';
import ExpenseClaimsHero from '../../components/HostPayments/ExpenseClaims/ExpenseClaimsHero';
import ExpenseClaimsList from '../../components/HostPayments/ExpenseClaims/ExpenseClaimsList';

export const ExpenseClaimsPage = () => {
    const loggedInUser = UserRole();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const { data: expenseClaims }: any = useGetExpenseClaimsQuery({});

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`);
        }
    }, []);

    const navigate = useNavigate();

    return (
        <Stack
            sx={{
                width: '100%',
                height: isMobile || isIpad ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                }}
            >
                <Typography variant='h1'>Expense Claims</Typography>
                <Typography
                    sx={{
                        fontSize: '12px',
                        paddingTop: '10px',
                    }}
                >
                    Expense claims are requests for reimbursement of costs
                    incurred while providing a service or completing a task.
                    They refer to costs related to guest bookings that you can
                    submit for payment from the guest.
                </Typography>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    minHeight: isMobile || isIpad ? '65%' : '100%',
                    justifyContent: 'left',
                }}
            >
                <ExpenseClaimsHero expenses={expenseClaims} />
                <ExpenseClaimsList expenses={expenseClaims} />
            </Box>
        </Stack>
    );
};
